// import otterSticker from '../images/stickers/otterSticker.png';
// import momSticker from '../images/stickers/momSticker.png';
// import daisySticker from '../images/stickers/daisySticker.png';
import heartSticker from '../images/stickers/heartSticker.png'
import flowershopSticker from '../images/stickers/flowershopSticker.png'
import butterflySticker from '../images/stickers/butterflySticker.png'
import smileSticker from '../images/stickers/smileSticker.png'

const stickers = [
    {
        "name": 'flowershopSticker',
        "src": flowershopSticker,
        "alt": 'white sticker with e-florals logo'
    },
    {
        "name": 'butterflySticker',
        "src": butterflySticker,
        "alt": 'white sticker with e-florals logo'
    },
        {
        "name": 'smileSticker',
        "src": smileSticker,
        "alt": 'white sticker with e-florals logo'
    },
        {
        "name": 'heartSticker',
        "src": heartSticker,
        "alt": 'dark pink heart shaped sticker with inner light pink hearts'
    },
    // archive mothers day stickers - but keep images to save for next year
    // {
    //     "name": 'otterSticker',
    //     "src": otterSticker,
    //     "alt": 'beige sticker of an otter mom holding up an otter baby'
    // },
    // {
    //     "name": 'momSticker',
    //     "src": momSticker,
    //     "alt": 'pink sticker with a large heart reading mom'
    // },
    // {
    //     "name": 'daisySticker',
    //     "src": daisySticker,
    //     "alt": 'pink sticker with a large heart reading mom'
    // },
]

export default stickers;